import React from 'react'
import { connect } from 'react-redux'
import { parse } from 'qs'
import ReCAPTCHA from 'react-google-recaptcha'
import { getRecaptchaKey } from 'util/recaptcha'
import { clearHeader, clearSkip } from 'actions/general'
import LoginForm from './form'
import { postLogin } from 'actions/login'
import { getGithubAuthLinkLogin } from 'util/github-auth'
import {
  RecoverPasswordRoute,
  RecoverUsernameRoute,
  SingleSignOnRoute,
} from 'resources/routes'
import { Link } from 'react-router-dom'
import Mobile from 'containers/mobile'
import { isDeviceMobile } from 'util/mobile'
import withRouter from '../../hocs/with-router'

function mapStateToProps(state) {
  return {
    redirectUrl: state.general.get('portalUrl', null),
    loading: state.login.get('loading', false),
    submitError: state.login.get('error', false),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    clearHeader: payload => dispatch(clearHeader(payload)),
    clearSkip: payload => dispatch(clearSkip(payload)),
    postLogin: payload => dispatch(postLogin(payload)),
  }
}

class Login extends React.PureComponent {
  state = {
    mobileView: isDeviceMobile(),
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !this.props.submitError &&
      this.props.redirectUrl &&
      this.state.queryParamReturnTo &&
      !this.state.recaptchaPending
    ) {
      window.location.href = this.state.queryParamReturnTo
    } else if (!this.props.submitError && this.props.redirectUrl) {
      window.location.href = this.props.redirectUrl
    }
  }

  componentDidMount() {
    this.props.clearHeader()
    this.props.clearSkip()

    const { returnTo } = parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    })
    this.setState({
      queryParamReturnTo: returnTo,
      isStakeholderLocalStorage:
        localStorage.getItem('isStakeholderLocalStorage') === 'true',
    })
  }

  _submit(values) {
    if (this.recaptcha.getValue()) {
      this.recaptcha.reset()
    }
    return new Promise((resolve, reject) => {
      this.setState(
        {
          values: { ...values },
          recaptchaPending: true,
        },
        () => {
          this.resolve = resolve
          this.reject = reject
          if (sessionStorage.getItem('disableRecaptcha') === 'true') {
            // for Selenium and DAST scans
            this._recaptchaChange('disabledForTesting')
          } else {
            this.recaptcha.execute()
          }
        }
      )
    }).then(() => {
      this.setState({ recaptchaPending: false })
    })
  }

  _recaptchaChange = value => {
    const values = this.state.values
    values.captchaToken = value
    this.props.postLogin({
      values,
      resolve: this.resolve,
      reject: this.reject,
      queryParamReturnTo: this.state.queryParamReturnTo,
    })
  }

  _loginWithGithub() {
    window.location.assign(getGithubAuthLinkLogin())
  }

  onSkip = () => {
    this.setState({ mobileView: false })
  }

  render() {
    // If the user originally went to a link with '/stakeholder' in the url then they skip the mobile download page
    // Or if the isStakeholder flag in localStorage is set to true then they skip the mobile download page
    const handleAsStakeholder =
      (this.state.queryParamReturnTo &&
        this.state.queryParamReturnTo.endsWith('/stakeholders')) ||
      this.state.isStakeholderLocalStorage

    if (this.state.mobileView && !handleAsStakeholder) {
      return <Mobile redirectText='or continue to login' onSkip={this.onSkip} />
    } else {
      return (
        <div className='user'>
          <h1 className='heading--main'>Sign in</h1>
          <LoginForm
            onSubmit={values => this._submit(values)}
            loading={this.props.loading}
          />

          <div className='form-group'>
            <button className='btn btn--github' onClick={this._loginWithGithub}>
              Sign in with GitHub
            </button>
          </div>

          <Link className='user--link' to={SingleSignOnRoute}>
            Single Sign On
          </Link>
          <Link className='user--link' to={RecoverPasswordRoute}>
            Forgot password?
          </Link>
          <Link className='user--link' to={RecoverUsernameRoute}>
            Forgot username?
          </Link>
          <a
            className='user--link'
            href='https://www.splunk.com/en_us/download/on-call.html'
          >
            Need an account?
          </a>
          <ReCAPTCHA
            ref={recaptcha => {
              this.recaptcha = recaptcha
            }}
            size='invisible'
            sitekey={getRecaptchaKey()}
            onChange={this._recaptchaChange}
          />
        </div>
      )
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login))
